import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Button, Modal, Header } from '@adc/ui-core'
import classnames from 'classnames/bind'
import { requiredIf } from '../../utils'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const dataElmId = 'unsaved_changes_modal'

const UnsavedChangesModal = ({
  isModalOpen,
  allowContinueWithoutSaving,
  allowSaveAndContinue,
  onContinueWithoutSaving,
  onKeepEditing,
  onSaveAndContinue,
  headerContent = 'Unsaved Changes',
  modalContent = 'Would you like to save your changes before leaving this page?',
  fieldContent,
  continueWithoutSavingText = 'Continue Without Saving',
  keepEditingText = 'Keep Editing',
  saveAndContinueText = 'Save And Continue',
}) => {
  const onModalButtonClick = event => {
    const buttonId = event.currentTarget.id

    if (buttonId === 'continue_without_saving') {
      onContinueWithoutSaving()
    } else if (buttonId === 'keep_editing') {
      onKeepEditing()
    } else if (buttonId === 'save_and_continue') {
      onSaveAndContinue()
    }
  }

  if (!isModalOpen) {
    return null
  }

  return (
    <Modal
      className={cx('unsaved-changes-modal')}
      closeOnDimmerClick={false}
      data-elm-id={dataElmId}
      size='small'
      open={isModalOpen}
      closeIcon={false}
    >
      <Header data-elm-id={`${dataElmId}_header`}>
        <Icon name='warning sign' size='big' color='caution' />
        <Header.Content>{headerContent}</Header.Content>
      </Header>
      <Modal.Content>
        {!!modalContent.length && <p>{modalContent}</p>}
        {fieldContent}
      </Modal.Content>
      <Modal.Actions>
        {allowContinueWithoutSaving && (
          <Button
            size='small'
            role='secondary'
            id='continue_without_saving'
            elmId={`${dataElmId}_continue_without_saving_button`}
            onClick={onModalButtonClick}
          >
            {continueWithoutSavingText}
          </Button>
        )}
        <Button
          size='small'
          role={allowSaveAndContinue ? 'secondary' : 'primary'}
          id='keep_editing'
          elmId={`${dataElmId}_keep_editing_button`}
          onClick={onModalButtonClick}
        >
          {keepEditingText}
        </Button>
        {allowSaveAndContinue && (
          <Button
            role='primary'
            size='small'
            id='save_and_continue'
            elmId={`${dataElmId}_save_and_continue_button`}
            onClick={onModalButtonClick}
          >
            {saveAndContinueText}
          </Button>
        )}
      </Modal.Actions>
    </Modal>
  )
}

UnsavedChangesModal.propTypes = {
  allowContinueWithoutSaving: PropTypes.bool,
  allowSaveAndContinue: PropTypes.bool,
  isModalOpen: PropTypes.bool.isRequired,
  onContinueWithoutSaving: requiredIf(
    PropTypes.func,
    props => props.allowContinueWithoutSaving
  ),
  onKeepEditing: PropTypes.func.isRequired,
  onSaveAndContinue: requiredIf(
    PropTypes.func,
    props => props.allowSaveAndContinue
  ),
  headerContent: PropTypes.string,
  modalContent: PropTypes.string,
  continueWithoutSavingText: PropTypes.string,
  keepEditingText: PropTypes.string,
  saveAndContinueText: PropTypes.string,
  fieldContent: PropTypes.object,
}

export default UnsavedChangesModal
